/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';

import {AdvertisingSharedModule} from '../../advertising/advertising-shared.module';
import {LineItemModule} from '../../line-item/line-item.module';
import {TeamAnalysisPageComponent} from './team-analysis-page.component';
import {TeamCopyModalComponent} from './team-copy-modal.component';
import {TeamEditFeesComponent} from './team-edit-fees.component';
import {TeamEditPageComponent} from './team-edit-page.component';
import {TeamFeeComponent} from './team-fee-component';
import {TeamItemPageComponent} from './team-item-page.component';
import {TeamListPageComponent} from './team-list-page.component';
import {TeamObjectMembershipModalComponent} from './team-object-membership-modal.component';
import {TeamOwnershipModalComponent} from './team-ownership-modal.component';

const TEAM_COMPONENTS = [
  TeamAnalysisPageComponent,
  TeamCopyModalComponent,
  TeamEditFeesComponent,
  TeamEditPageComponent,
  TeamFeeComponent,
  TeamItemPageComponent,
  TeamListPageComponent,
  TeamObjectMembershipModalComponent,
  TeamOwnershipModalComponent
];

@NgModule({
  imports: [
    AdvertisingSharedModule,
    LineItemModule
  ],
  declarations: TEAM_COMPONENTS,
  exports: TEAM_COMPONENTS
})
export class TeamModule {
}
